import { useEffect } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { NavMarker } from 'react-rhumb';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { useAcademyLabsSessionUsageTracking } from '../hooks/academyLabsHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TopBar = ({
  originPortalId
}) => {
  const onBackToAcademyClick = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'academy-labs-back-to-academy-clicked',
      customerHubId: originPortalId
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-accent-purple-default",
    inlineSize: "100%",
    justifyContent: "space-between",
    minBlockSize: "60px",
    paddingBlock: "400",
    paddingInline: "500",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Logo, {
        blockSize: "22px",
        name: "hubspot-wordmark--light"
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-core-on-fill-default",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.academyLabs.session.banner.title"
        })
      })]
    }), /*#__PURE__*/_jsx(ButtonWrapper, {
      children: /*#__PURE__*/_jsx(Button, {
        external: true,
        href: `${getFullUrl('app')}/academy/${originPortalId || PortalIdParser.get()}`,
        onClick: onBackToAcademyClick,
        size: "small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.academyLabs.session.banner.academyCta"
        })
      })
    })]
  });
};
export const AcademyLabsSession = () => {
  const [searchParams] = useSearchParams();
  const labsPortalId = PortalIdParser.getPortalIdFromPath();
  const originPortalId = searchParams.originPortalId;
  useAcademyLabsSessionUsageTracking({
    originPortalId,
    simulationPortalId: labsPortalId,
    skip: !labsPortalId
  });
  useEffect(() => {
    if (labsPortalId) {
      Metrics.counter('academy-labs-session-started').increment();
    }
  }, [labsPortalId]);
  if (!labsPortalId) {
    return null;
  }
  const iframeUrl = `${getFullUrl('app')}/contacts/${labsPortalId}/objects/0-1`;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-accent-purple-default",
    children: /*#__PURE__*/_jsx(EditorPage, {
      hasScrolling: true,
      headerComponent: /*#__PURE__*/_jsx(TopBar, {
        originPortalId: originPortalId
      }),
      headerWrapperStyles: {
        backgroundColor: 'fill-accent-purple-default',
        insetBlockStart: '1px'
      },
      inset: "0",
      mainSectionFlush: true,
      position: "absolute",
      use: "dark",
      zIndex: '1111',
      children: /*#__PURE__*/_jsxs(Flex, {
        blockSize: "100%",
        inlineSize: "100%",
        children: [/*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-accent-purple-default",
          flexShrink: 0,
          inlineSize: "16px"
        }), /*#__PURE__*/_jsx(View, {
          flex: 1,
          position: "relative",
          children: /*#__PURE__*/_jsx(NavMarker, {
            name: "ACADEMY_LABS_SESSION_LOADED",
            children: /*#__PURE__*/_jsx("iframe", {
              "data-test-id": "academy-labs-session-iframe",
              id: "academy-labs-session-iframe",
              src: iframeUrl,
              style: {
                width: '100%',
                height: '100%',
                border: 0,
                overflow: 'scroll',
                position: 'absolute'
              }
            })
          })
        })]
      })
    })
  });
};